
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import lodash from 'lodash'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import SwiperBtn from '../swiperBtn/index.vue'
import ComCard from '../card/comCard.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    ComCard,
    NewSwiper,
    SwiperBtn
  }
})
export default class extends Vue {
  @Prop() dataSource: ComCard[]

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  data: ComCard[][] = []

  activeIndex: number = 0

  handleChange(index) {
    this.activeIndex = index
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {
    this.data = lodash.chunk(this.dataSource, 4)
  }

  activated(): void {
    this.activeIndex = 0
  }

  deactivated(): void {}

  updated(): void {}

  destroyed(): void {}
}
